// extracted by css-extract-rspack-plugin
var _1 = "src-components-LeftBar-ChatList-ChatList-module__chat-item-vhC7cc";
var _2 = "src-components-LeftBar-ChatList-ChatList-module__chat-list-Y8vpRM";
var _3 = "src-components-LeftBar-ChatList-ChatList-module__chat-item-vhC7cc";
var _4 = "src-components-LeftBar-ChatList-ChatList-module__chat-list-Y8vpRM";
var _5 = "src-components-LeftBar-ChatList-ChatList-module__collapsed-NBOXgR";
var _6 = "src-components-LeftBar-ChatList-ChatList-module__main-text-AmyRAF";
var _7 = "src-components-LeftBar-ChatList-ChatList-module__main-text-AmyRAF";
var _8 = "src-components-LeftBar-ChatList-ChatList-module__no-chats-container-iw_qE6";
var _9 = "src-components-LeftBar-ChatList-ChatList-module__no-chats-container-iw_qE6";
var _a = "src-components-LeftBar-ChatList-ChatList-module__sub-text-QPwWPG";
var _b = "src-components-LeftBar-ChatList-ChatList-module__sub-text-QPwWPG";
export { _1 as "chat-item", _2 as "chat-list", _3 as "chatItem", _4 as "chatList", _5 as "collapsed", _6 as "main-text", _7 as "mainText", _8 as "no-chats-container", _9 as "noChatsContainer", _a as "sub-text", _b as "subText" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"chat-item\":\"src-components-LeftBar-ChatList-ChatList-module__chat-item-vhC7cc\",\"chat-list\":\"src-components-LeftBar-ChatList-ChatList-module__chat-list-Y8vpRM\",\"chatItem\":\"src-components-LeftBar-ChatList-ChatList-module__chat-item-vhC7cc\",\"chatList\":\"src-components-LeftBar-ChatList-ChatList-module__chat-list-Y8vpRM\",\"collapsed\":\"src-components-LeftBar-ChatList-ChatList-module__collapsed-NBOXgR\",\"main-text\":\"src-components-LeftBar-ChatList-ChatList-module__main-text-AmyRAF\",\"mainText\":\"src-components-LeftBar-ChatList-ChatList-module__main-text-AmyRAF\",\"no-chats-container\":\"src-components-LeftBar-ChatList-ChatList-module__no-chats-container-iw_qE6\",\"noChatsContainer\":\"src-components-LeftBar-ChatList-ChatList-module__no-chats-container-iw_qE6\",\"sub-text\":\"src-components-LeftBar-ChatList-ChatList-module__sub-text-QPwWPG\",\"subText\":\"src-components-LeftBar-ChatList-ChatList-module__sub-text-QPwWPG\"}";
        // 1752373455111
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  